/**
 * Contenido del portal público (rutas desde `MEMBERSHIP_ROUTE` en `membershipAccessFlow`).
 */

import type { MembershipFunnelPath } from "@/lib/membershipAccessFlow";
import { MEMBERSHIP_ROUTE } from "@/lib/membershipAccessFlow";

export interface MembershipPortalStepDef {
  path: MembershipFunnelPath;
  title: string;
  body: string;
  cta: string;
  highlight?: boolean;
}

/** Orden = secuencia típica después del pago. */
export const MEMBERSHIP_PORTAL_STEPS: MembershipPortalStepDef[] = [
  {
    path: MEMBERSHIP_ROUTE.REGISTRO,
    title: "Acabo de pagar (cualquier plan de membresía)",
    body:
      "Después del pago, el sitio suele traerte acá para crear tu cuenta. Si cerraste la pestaña o no ves el formulario, abrí este enlace y usá el mismo correo que usaste al pagar.",
    cta: "Crear cuenta",
  },
  {
    path: MEMBERSHIP_ROUTE.COMPLETAR_REGISTRO,
    title: "Ya tengo cuenta y me falta completar el perfil",
    body:
      "Alias, Telegram y fecha de nacimiento. Al guardar pasás al paso «En revisión» (In review) antes del acceso.",
    cta: "Completar perfil → En revisión",
  },
  {
    path: MEMBERSHIP_ROUTE.PENDING_APPROVAL,
    title: "En revisión — ya envié el perfil",
    body:
      "Estás en el paso «In review / En revisión»: el equipo revisa tu cuenta y el pago y prepara tu link privado. La página se actualiza sola cuando te aprueben.",
    cta: "Ver estado: En revisión",
    highlight: true,
  },
  {
    path: MEMBERSHIP_ROUTE.MI_ACCESO,
    title: "Ya me aprobaron",
    body:
      "Ahí figura el link privado de ingreso (Telegram u otro canal) que te asignaron.",
    cta: "Ver mi acceso",
  },
  {
    path: MEMBERSHIP_ROUTE.ENTRAR,
    title: "Solo quiero iniciar sesión",
    body:
      "Si ya tenés cuenta y no estás en medio del alta de membresía.",
    cta: "Iniciar sesión",
  },
];
